<template>
  <main-layout>
    <!--  左メニュー 開始  -->
    <div slot="left-side">
      <menubar :screenIdParam="screenIdParam"></menubar>
    </div>
    <!--  左メニュー 終了 -->

    <!-- ヘッダー行 開始-->
    <el-row slot="header">
      <head-title class="cancel-width">
        <label slot="title">{{ titleName }}</label>
        <lvory-but
          @click="back"
          slot="cancel">
            {{ $t("button.common.data.cancel") }}
        </lvory-but>
        <narrow-down
          @click="batchImport"
          slot="create"
          :disabled="showLoading">
            {{$t('button.common.data.capture')}}
        </narrow-down>
      </head-title>
    </el-row>
    <br>
    <!--   ヘッダー行 終了   -->

    <div slot="body">
      <!-- subtitle -->
      <div class="main-title">
        {{ $t("label.system.import.title", {
          field: this.titleName,
        }) }}
      </div>
      <el-row>
        <el-col>
          <el-form
            label-width="200px"
            label-position="left"
          >
            <el-row>
              <el-col>
                <el-form-item
                  size="small"
                  :label="$t('label.system.building.import.file')"
                >
                  <div class="form-group">
                    <index
                      :readonly=true
                      :newValue="this.fileName"
                      :placeholderParam="$t('label.system.owner.salesMachine.file')">
                    </index>
                    <selectBtn
                      @click="uploadfile"
                      class="margin-left upload-button-color">
                      {{$t('label.system.owner.salesMachine.fileUpload')}}
                    </selectBtn>
                  </div>
                </el-form-item>

                <input
                  ref="csvUpload"
                  type="file"
                  style="display:none"
                  accept=".csv,.CSV"
                  @change="getCsvfile">

                <el-form-item
                  prop="ownerId"
                  size="small"
                  :label="$t('label.system.building.import.result')"
                >
                  <el-input
                    :readonly=true
                    id="textarea_result"
                    type="textarea"
                    :autosize="{ minRows: 16, maxRows: 32}"
                    class="in-files-results">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
      <el-dialog-prompt
        :centerDialogVisibleParam.sync="centerDialogVisibleIsShow"
        :msgParam="msgParam">
      </el-dialog-prompt>
      <loading-dialog :dialogVisible="showLoading" />
    </div>
  </main-layout>
</template>

<script>
import NewDesignLayout from "@/layout/NewDesignLayout"
import SystemManageApi from "@/api/SystemManageApi"
import LoadingDialog from "@/components/common/loading/LoadingDialog"
import headTitle from "@/components/common/head/head"
import LvoryBut from "@/components/common/generalButton/LvoryBut"
import narrowDown from "@/components/common/generalButton/NarrowDown"
import index from "@/components/common/input/index"
import selectBtn from "@/components/common/generalButton/Select"
import Menubar from "@/components/leftmenu/DashBoard"
import errorCodeMsg from "@/utils/error-code-msg"
import statusErrorCodeMsg from "@/utils/status-error-msg"
import elDialogPrompt from "@/components/common/el-dialog-prompt"
export default {
  components:{
    MainLayout: NewDesignLayout,
    headTitle,
    LvoryBut,
    narrowDown,
    index,
    selectBtn,
    LoadingDialog: LoadingDialog,
    elDialogPrompt,
    menubar: Menubar
  },
  data(){
    return{
      screenIdParam: null,
      titleName: null,
      msgParam: "",
      centerDialogVisibleIsShow:false,
      showLoading: false,
      query:{
        file:null
      },
      result:{
        successCount:null,
        errorCount:null,
        uploadResult:[{
          lineNo:null,
          message:null
        }]
      },
      resultstr:'',
      fileName:null
    }
  },
  methods:{

    //ファイルを取得
    getCsvfile(){
      let csvFile = this.$refs.csvUpload.files[0]
      var csvCheck = /\.(csv|CSV)$/
      if (!csvCheck.test(csvFile.name)) {
        this.query.file = null
        this.msgParam = this.$t('message.common.validation.fileFormat')
        this.centerDialogVisibleIsShow = true
      } else {
        this.query.file = csvFile
        this.fileName = csvFile.name
      }

      const isLt2M = csvFile.size / 1024 / 1024 < 15;
      if (!isLt2M) {
          this.fileName = null;
          this.$messageIotError(this.$t('message.common.error.ERR_FILE_SIZE_OVER_MSG',{size:'15M'}));
          return this.query.file = null
      }
      if (csvFile.size == 0) {
          this.fileName = null;
          this.$messageIotError(this.$t('message.common.error.ERR_FILE_EMPTY_MSG'));
          return this.query.file = null
      }
    },

    //アップロード入力ボックスを開く
    uploadfile() {
      document.getElementById('textarea_result').value = null
      this.query.file = null
      this.fileName = ''
      this.$refs.csvUpload.value = null
      this.$refs.csvUpload.click()
    },

    //戻る
    back () {
      if(this.type == '03'){
        this.$router.push({
          name:"system-area-search",
        })
      } else if (this.type == '04') {
        this.$router.push({
          name:"system-tenant-search",
        })
      } else if (this.type == '05') {
        this.$router.push({
          name:"system-meetingRoom-search",
        })
      } else if (this.type == '06') {
        this.$router.push({
          name:"system-fixDesk-search",
        })
      }else if (this.type == '07') {
        this.$router.push({
          name:"system-setting-location-list",
        })
      }

    },
    batchImport(){
      if (this.showLoading) {
        return
      }
      if(this.query.file == null){
        this.msgParam = this.$t('message.common.validation.required', {
          field: this.$t('label.system.owner.salesMachine.file')
        })
        this.centerDialogVisibleIsShow = true
      }else{
        this.showLoading = true
        SystemManageApi.batchImport({
          csvFile: this.query.file,
        },this.type)
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({ data }) => {
          if(!statusErrorCodeMsg(data.statusCode, this)) {
            return this.query.file = null;
          }
          if (data.body.failureCount > 0) {
              this.resultstr = this.$t('message.common.csvImport.ERR_FAILURE_MSG');
          } else {
              this.resultstr = this.$t('message.common.csvImport.INFO_SUCCESS_AMOUNT_MSG',{amount:data.body.successCount});
          }
          for (let i = 0; i < data.body.failureDetails.length; i++) {
              let failureDetail = data.body.failureDetails[i]
              let ownerItem = ''
              ownerItem = failureDetail.message.includes(':') ? failureDetail.message.split(':')[1] : '';
              let msg = ''
              msg = failureDetail.message.includes(':') ? failureDetail.message.split(':')[0] : failureDetail.message;
              this.resultstr = this.resultstr + "\r\n" + this.$t('message.common.csvImport.ERR_' + msg + "_MSG",
                {
                  row:failureDetail.lineNo,
                  column:failureDetail.itemIndex
                });
              if(ownerItem != ''){
                this.resultstr = this.resultstr + ":" + ownerItem
              }

            }

            // アップロードファイル数が上限を超えた場合、エラーメッセージ「アップロードするファイルの数は上限の {maxCount} を超えることはできません。」を表示する。
            if(data.body.uploadMaxCount && data.body.failureDetails && data.body.failureDetails[0].message == "File_Exceeded_Upload_Limit"){
              this.resultstr = this.$t('message.common.csvImport.ERR_FILE_EXCEEDED_UPLOAD_LIMIT_MSG',{maxCount:data.body.uploadMaxCount });
            }

            document.getElementById('textarea_result').value = this.resultstr
        })
        .finally(() => {
          this.showLoading = false
        })
      }
    }
  },
  created(){
    this.type = this.$route.query.type;
    this.screenIdParam = this.$route.query.screenIdParam;

    if( this.type == '03') {
      this.titleName = this.$t("label.system.import.area")
    } else if(this.type == '04') {
      this.titleName = this.$t("label.system.import.tenant")
    } else if(this.type == '05') {
      this.titleName = this.$t("label.system.import.meetingRoom")
    } else if(this.type == '06') {
      this.titleName = this.$t("label.system.import.fixDesk")
    }else if(this.type == '07'){
      this.titleName = this.$t("label.system.import.locationGUID")
    }
    //this.$authCheck("010305")

     let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "",
        title: this.titleName,
      },
      {
        path: "",
        title: this.$t("label.system.import.title", {
          field: this.titleName,
        }),
      }
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb)
  }
}
</script>

<style lang="scss" scoped>
::v-deep .cancel-width{
  .my-button{
    width: 152px;
    height: 32px;
  }
}
.margin-left{
  margin-left: 20px;
}
::v-deep input::-webkit-input-placeholder {
  font-size: 14px;
  color: #B8B8B4;
}
.font-top{
  position: relative;
  top: 11px;
}
/* No.130 start */
::v-deep .el-form-item__content{
  position: absolute;
  margin-left: 140px !important;
}
::v-deep .el-textarea__inner{
  min-height:237px !important;
  height: 237px !important;
  width: 596px !important;
  background-color: #DEDED9 !important;
  border-radius: 6px !important;
  box-shadow: none !important;
}
::v-deep .el-form-item--small .el-form-item__label {
  height: 44px;
  line-height: 44px;
}
.in-files-results {
  margin-top: 8px;
}
.upload-button-color {
  ::v-deep .my-button {
    background-color: #F7F7F2 !important;
  }
}
/* No.130 end */
</style>
